// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { GridItemProps } from "@insite/mobius/GridItem";
import { partNumbersStyle } from "@pace/App/ComponentExtensions/ProductPartNumbersExtensions";
import cartLineSharedStyles from "@pace/App/SharedStyles/CartLineSharedStyles";
import { productInformationStyles } from "@pace/Overrides/Widgets/ProductList/ProductListProductInformation";
import { constants } from "@pace/XDL/constants";
import { mergeWithCss, sharedBadgeStyle, xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

const partNumberGridItemStyles: GridItemProps = {
    width: [12, 12, 6, 6, 6],
    css: css`
        flex-direction: column;
        gap: 4px;
        ${xScreen("lte", constants.productList.breakpoints.md)} {
            flex-direction: row;
        }
    `,
};
productInformationStyles.container = {
    gap: 0,
    offsetCss: css``,
};

productInformationStyles.descriptionStyles = {
    ...mergeWithCss(cartLineSharedStyles.productDescription, {
        productDetailLink: {
            css: css`
                display: flex;
                min-height: unset;
                margin-bottom: 8px;
            `,
        },
    }),
};

productInformationStyles.partNumbersStyles = {
    customerNameGridItem: {
        ...partNumberGridItemStyles,
    },
    erpNumberGridItem: {
        ...partNumberGridItemStyles,
    },
    manufacturerItemGridItem: {
        ...partNumberGridItemStyles,
    },
};

productInformationStyles.attributes = {
    container: {
        gap: 0,
        offsetCss: css`
            margin-top: 12px;
            row-gap: 4px;
        `,
    },
    attributeTypeGridItem: {
        ...partNumberGridItemStyles,
    },
    attributeValueGridItem: {
        ...partNumberGridItemStyles,
    },
    attributeTypeText: {
        ...partNumbersStyle.label,
    },
    attributeValueText: {
        ...partNumbersStyle.value,
    },
};

productInformationStyles.textBadge = {
    badge: {
        css: css`
            & > div {
                padding: 6px;
                border-radius: 4px;
                width: fit-content;
            }
        `,
    },
    badgeText: {
        ...sharedBadgeStyle.badgeText,
    },
};
